import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Box,
  Center,
  Heading,
  HStack,
  Spinner,
  Text,
  VStack,
} from "native-base";
import { Helmet } from "react-helmet-async";
import { MdArrowRight } from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import styles from "./styles.module.css";
import colors from "../../../../constants/colors";
import routes from "../../../../routes";
import { StateContext, StatusContext } from "../../../../contexts";
import moment from "moment";
import API from "../../../../api";
import Cell from "../../../../components/cell";
import { formatToCurrency } from "../../../../utils";

function getPaymentMethod(transaction) {
  if (transaction.payment) {
    return "Tarjeta crédito o débito";
  } else if (transaction.userMovement) {
    return "Saldo Autotur";
  } else {
    return "";
  }
}

function AgencyPaymentManagementPassengersInstallmentsPage() {
  const params = useParams();
  const state = useContext(StateContext);
  const status = useContext(StatusContext);
  const [isLoading, setIsLoading] = useState(true);
  const [bookings, setBookings] = useState([]);
  const [date, setDate] = useState(moment());

  const getTransactions = useCallback(async () => {
    setIsLoading(true);
    try {
      const {
        data: { data },
        // TODO: Optimize request
      } = await API(state.jwt).get(`/tours/${params.id}`);
      const origin = data.itinerary.find(
        (location) => !location.isReturn && location.type === "origin",
      );
      setDate(moment(origin.departureDate));
      setBookings(data.services.flatMap((service) => service.bookings));
    } catch (error) {
      status.updateErrorMessage(error);
    }
    setIsLoading(false);
  }, [params.id, state.jwt, status]);

  useEffect(() => {
    getTransactions();
  }, [getTransactions]);

  return (
    <VStack>
      <Helmet>
        <title>Gestión de cobros</title>
      </Helmet>
      <HStack paddingY={8} space={5} alignItems="flex-start">
        <Heading color={colors.secondary} fontSize="2xl">
          Gestión de cobros
        </Heading>
        <MdArrowRight color={colors.secondary} size={25} />
        <Heading color={colors.secondary} fontSize="2xl">
          Abonos
        </Heading>
        <Box width={10} />
        <HStack
          padding={1}
          backgroundColor={colors.lighterGray}
          borderRadius={10}
          space={1}>
          <Link
            to={routes.agencyPaymentManagementInstallments.replace(
              ":id",
              params.id,
            )}>
            <Box borderRadius={10} paddingY={2} paddingX={8}>
              <Text color={colors.primary}>Empresa</Text>
            </Box>
          </Link>
          <Link
            to={routes.agencyPaymentManagementPassengersInstallments.replace(
              ":id",
              params.id,
            )}>
            <Box
              backgroundColor={colors.white}
              borderRadius={10}
              paddingY={2}
              paddingX={8}>
              <Text color={colors.gray}>Pasajeros</Text>
            </Box>
          </Link>
        </HStack>
      </HStack>
      <VStack backgroundColor={colors.white} paddingX={6} paddingY={8}>
        {isLoading ? (
          <Center height={300}>
            <Spinner size="lg" color={colors.primary} />
          </Center>
        ) : (
          <VStack space={10}>
            <HStack
              alignItems="center"
              justifyContent="center"
              backgroundColor={colors.stepper}
              borderRadius={5}
              padding={10}
              position="relative"
              space={5}
              minH={250}>
              <VStack
                alignItems="center"
                justifyContent="center"
                backgroundColor={colors.white}
                paddingY={7}
                paddingX={10}
                borderRadius={15}>
                <Heading color={colors.secondary} fontSize="xl">
                  Abonos realizados
                </Heading>
                <Heading color={colors.secondary}>
                  {formatToCurrency(
                    bookings.reduce(
                      (total, booking) => total + booking.transaction.amount,
                      0,
                    ),
                  )}
                </Heading>
              </VStack>
              <VStack
                backgroundColor={colors.white}
                position="absolute"
                top={6}
                right={6}
                padding={4}
                paddingRight={20}
                borderRadius={5}>
                <Heading fontSize="xl">Fecha límite</Heading>
                <Text>
                  {date
                    .clone()
                    .subtract(3, "days")
                    .format(moment.HTML5_FMT.DATE)}
                </Text>
              </VStack>
            </HStack>
            <Heading color={colors.secondary} fontSize="2xl">
              Transacciones
            </Heading>
            <table className={styles.table}>
              <thead>
                <tr>
                  <Cell color={colors.gray}>Nombre del cliente</Cell>
                  <Cell color={colors.gray}>Asiento</Cell>
                  <Cell color={colors.gray}>Fecha</Cell>
                  <Cell color={colors.gray}>Ref</Cell>
                  <Cell color={colors.gray}>Estatus</Cell>
                  <Cell color={colors.gray}>Método de pago</Cell>
                  <Cell color={colors.gray}>Importe</Cell>
                </tr>
              </thead>
              <tbody>
                {bookings
                  .sort((a, b) => b.id - a.id)
                  .map((booking, index) => (
                    <tr key={String(index)}>
                      <Cell bold>
                        {booking.user.firstName} {booking.user.lastName}
                      </Cell>
                      <Cell>{booking.seat}</Cell>
                      <Cell>
                        <VStack>
                          <Text bold>
                            {moment(booking.createdAt).format(
                              moment.HTML5_FMT.DATE,
                            )}
                          </Text>
                          <Text>
                            {moment(booking.createdAt).format("hh:mm a")}
                          </Text>
                        </VStack>
                      </Cell>
                      <Cell bold>{booking.id}</Cell>
                      <Cell bold>Creada</Cell>
                      <Cell bold>{getPaymentMethod(booking.transaction)}</Cell>
                      <Cell bold>
                        {formatToCurrency(booking.transaction.amount)}
                      </Cell>
                    </tr>
                  ))}
              </tbody>
            </table>
          </VStack>
        )}
      </VStack>
    </VStack>
  );
}

export default AgencyPaymentManagementPassengersInstallmentsPage;
